import React from "react";
import { steps } from "../data/mock";
import { ArrowRight } from "lucide-react";

const HowItWorks = () => {
  return (
    <section className="section-pad bg-[#eef4ff]">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <span className="eyebrow">How it works</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1f44] mt-4">
            Our hassle-free{" "}
            <span className="text-[#3b9dff]">installation</span> process
          </h2>
          <p className="text-slate-500 mt-3 max-w-3xl mx-auto">
            From home TV installations and smart home automation to outdoor
            living setups and commercial solutions, our streamlined process
            ensures fast, professional, and expert installations tailored to
            your specific needs.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8 lg:p-10">
          <div className="grid md:grid-cols-4 gap-y-10 md:gap-x-12">
            {steps.map((s, i) => {
              const accents = [
                { badge: "bg-[#3b9dff]", ring: "ring-[#3b9dff]/20" },
                { badge: "bg-[#f59e0b]", ring: "ring-[#f59e0b]/20" },
                { badge: "bg-[#10b981]", ring: "ring-[#10b981]/20" },
                { badge: "bg-[#f43f5e]", ring: "ring-[#f43f5e]/20" },
              ];
              const a = accents[i % accents.length];
              return (
                <div key={s.step} className="relative text-center md:text-left">
                  <span className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl ${a.badge} text-white font-extrabold text-lg ring-4 ${a.ring} shadow-sm`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h4 className="text-lg font-bold text-[#0a1f44] mt-5 mb-2 leading-snug">
                    {s.title}
                  </h4>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {s.desc}
                  </p>
                  {i < steps.length - 1 && (
                    <span className="hidden md:flex absolute top-3 -right-9 w-7 h-7 rounded-full bg-[#eef4ff] items-center justify-center">
                      <ArrowRight className="w-4 h-4 text-[#3b9dff]" />
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
